export default "__VITE_ASSET__BrwL7Q2G__"